export const productsData = [
  // Women's Clothing
  {
    id: 1,
    name: "Elegant Summer Dress",
    category: "women",
    subcategories: ["all-clothing", "dresses"],
    categoryLabel: "Women's Clothing",
    price: "$89",
    badge: "NEW",
    gradient: "linear-gradient(135deg, #FFB6C1 0%, #FF69B4 100%)"
  },
  {
    id: 2,
    name: "Casual Stripe Top",
    category: "women",
    subcategories: ["all-clothing", "tops-tshirts"],
    categoryLabel: "Women's Clothing",
    price: "$45",
    gradient: "linear-gradient(135deg, #E8D8C8 0%, #C8B8A8 100%)"
  },
  {
    id: 3,
    name: "High-Waist Jeans",
    category: "women",
    subcategories: ["all-clothing", "jeans-trousers"],
    categoryLabel: "Women's Clothing",
    price: "$79",
    gradient: "linear-gradient(135deg, #4A6FA5 0%, #2C5282 100%)"
  },
  // Women's Footwear
  {
    id: 4,
    name: "Classic Leather Heels",
    category: "women",
    subcategories: ["all-footwear", "heels"],
    categoryLabel: "Women's Footwear",
    price: "$129",
    badge: "NEW",
    gradient: "linear-gradient(135deg, #8B7355 0%, #6B5A47 100%)"
  },
  {
    id: 5,
    name: "Comfortable Flats",
    category: "women",
    subcategories: ["all-footwear", "flats"],
    categoryLabel: "Women's Footwear",
    price: "$69",
    gradient: "linear-gradient(135deg, #C4A58B 0%, #9B8470 100%)"
  },
  {
    id: 6,
    name: "White Sneakers",
    category: "women",
    subcategories: ["all-footwear", "sneakers"],
    categoryLabel: "Women's Footwear",
    price: "$85",
    gradient: "linear-gradient(135deg, #F8F8F8 0%, #E0E0E0 100%)"
  },
  // Women's Accessories
  {
    id: 7,
    name: "Gold Necklace Set",
    category: "women",
    subcategories: ["all-accessories", "jewelry"],
    categoryLabel: "Women's Jewelry",
    price: "$149",
    badge: "TRENDING",
    gradient: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)"
  },
  {
    id: 8,
    name: "Designer Handbag",
    category: "women",
    subcategories: ["all-accessories", "bags-purses"],
    categoryLabel: "Women's Bags",
    price: "$199",
    gradient: "linear-gradient(135deg, #D4C4B0 0%, #A89884 100%)"
  },
  {
    id: 9,
    name: "Luxury Watch",
    category: "women",
    subcategories: ["all-accessories", "watches"],
    categoryLabel: "Women's Watches",
    price: "$299",
    gradient: "linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%)"
  },
  // Men's Clothing
  {
    id: 10,
    name: "Classic Polo Shirt",
    category: "men",
    subcategories: ["all-clothing", "tshirts-polos"],
    categoryLabel: "Men's Clothing",
    price: "$49",
    badge: "NEW",
    gradient: "linear-gradient(135deg, #4A90A4 0%, #2C5F6F 100%)"
  },
  {
    id: 11,
    name: "Formal Dress Shirt",
    category: "men",
    subcategories: ["all-clothing", "shirts"],
    categoryLabel: "Men's Clothing",
    price: "$69",
    gradient: "linear-gradient(135deg, #E8E8E8 0%, #D0D0D0 100%)"
  },
  {
    id: 12,
    name: "Slim Fit Jeans",
    category: "men",
    subcategories: ["all-clothing", "jeans"],
    categoryLabel: "Men's Clothing",
    price: "$89",
    gradient: "linear-gradient(135deg, #1A2332 0%, #0D1219 100%)"
  },
  {
    id: 13,
    name: "Leather Jacket",
    category: "men",
    subcategories: ["all-clothing", "jackets-coats"],
    categoryLabel: "Men's Outerwear",
    price: "$249",
    badge: "BESTSELLER",
    gradient: "linear-gradient(135deg, #2A2A2A 0%, #1A1A1A 100%)"
  },
  // Men's Footwear
  {
    id: 14,
    name: "Running Sneakers",
    category: "men",
    subcategories: ["all-footwear", "sneakers"],
    categoryLabel: "Men's Footwear",
    price: "$119",
    gradient: "linear-gradient(135deg, #FF6B6B 0%, #C92A2A 100%)"
  },
  {
    id: 15,
    name: "Oxford Dress Shoes",
    category: "men",
    subcategories: ["all-footwear", "formal-shoes"],
    categoryLabel: "Men's Footwear",
    price: "$159",
    gradient: "linear-gradient(135deg, #3A2A1A 0%, #2A1A0A 100%)"
  },
  {
    id: 16,
    name: "Casual Loafers",
    category: "men",
    subcategories: ["all-footwear", "casual-shoes"],
    categoryLabel: "Men's Footwear",
    price: "$99",
    gradient: "linear-gradient(135deg, #8B7355 0%, #6B5A47 100%)"
  },
  // Men's Accessories
  {
    id: 17,
    name: "Leather Wallet",
    category: "men",
    subcategories: ["all-accessories", "wallets"],
    categoryLabel: "Men's Accessories",
    price: "$59",
    gradient: "linear-gradient(135deg, #4A3C2E 0%, #2C2416 100%)"
  },
  {
    id: 18,
    name: "Sport Watch",
    category: "men",
    subcategories: ["all-accessories", "watches"],
    categoryLabel: "Men's Watches",
    price: "$199",
    badge: "NEW",
    gradient: "linear-gradient(135deg, #2C3E50 0%, #1A252F 100%)"
  },
  {
    id: 19,
    name: "Aviator Sunglasses",
    category: "men",
    subcategories: ["all-accessories", "sunglasses"],
    categoryLabel: "Men's Accessories",
    price: "$79",
    gradient: "linear-gradient(135deg, #FFD700 0%, #B8860B 100%)"
  },
  {
    id: 20,
    name: "Leather Belt",
    category: "men",
    subcategories: ["all-accessories", "belts"],
    categoryLabel: "Men's Accessories",
    price: "$45",
    gradient: "linear-gradient(135deg, #6B5A47 0%, #4A3C2E 100%)"
  }
];

export const categoriesData = [
  {
    id: 1,
    name: "Women's Clothing",
    label: "WOMEN'S FASHION",
    category: "women",
    subcategory: "all-clothing",
    gradient: "linear-gradient(135deg, #FFB6C1 0%, #FF69B4 100%)"
  },
  {
    id: 2,
    name: "Women's Footwear",
    label: "WOMEN'S SHOES",
    category: "women",
    subcategory: "all-footwear",
    gradient: "linear-gradient(135deg, #8B7355 0%, #6B5A47 100%)"
  },
  {
    id: 3,
    name: "Women's Accessories",
    label: "ACCESSORIES & JEWELRY",
    category: "women",
    subcategory: "all-accessories",
    gradient: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)"
  },
  {
    id: 4,
    name: "Men's Clothing",
    label: "MEN'S FASHION",
    category: "men",
    subcategory: "all-clothing",
    gradient: "linear-gradient(135deg, #4A4A4A 0%, #2A2A2A 100%)"
  },
  {
    id: 5,
    name: "Men's Footwear",
    label: "MEN'S SHOES",
    category: "men",
    subcategory: "all-footwear",
    gradient: "linear-gradient(135deg, #3A2A1A 0%, #2A1A0A 100%)"
  },
  {
    id: 6,
    name: "Men's Accessories",
    label: "WATCHES & MORE",
    category: "men",
    subcategory: "all-accessories",
    gradient: "linear-gradient(135deg, #B8956A 0%, #8B7355 100%)"
  },
  {
    id: 7,
    name: "Bags & Luggage",
    label: "BAGS COLLECTION",
    category: "bags",
    subcategory: "all",
    gradient: "linear-gradient(135deg, #6B4423 0%, #4A2F1A 100%)"
  },
  {
    id: 8,
    name: "New Arrivals",
    label: "TRENDING NOW",
    category: "new",
    subcategory: "all",
    gradient: "linear-gradient(135deg, #FF6B6B 0%, #C92A2A 100%)"
  }
];

export const heroSlidesData = [
  {
    id: 1,
    badge: "NEW ARRIVALS",
    title: "Discover the Latest Trends\nSpring Collection 2024",
    buttonText: "Shop Now",
    gradient: "linear-gradient(135deg, #FFB6C1 0%, #FF69B4 100%)"
  },
  {
    id: 2,
    title: "MegaGenie Exclusives",
    subtitle: "Premium quality, unbeatable prices",
    buttons: ["Shop Women's", "Shop Men's"],
    gradient: "linear-gradient(135deg, #8B7355 0%, #6B5A47 100%)"
  },
  {
    id: 3,
    title: "Style Your Way",
    subtitle: "Curated collections for every occasion",
    buttonText: "Explore Collections",
    gradient: "linear-gradient(135deg, #4A4A4A 0%, #2A2A2A 100%)"
  }
];

export const menuData = {
  women: {
    title: "Women",
    sections: [
      {
        title: "Clothing",
        items: [
          { label: "Tops & T-Shirts", subcategory: "tops-tshirts" },
          { label: "Dresses", subcategory: "dresses" },
          { label: "Jeans & Trousers", subcategory: "jeans-trousers" },
          { label: "Skirts & Shorts", subcategory: "skirts-shorts" },
          { label: "Sweaters & Jackets", subcategory: "sweaters-jackets" },
          { label: "Lingerie & Sleepwear", subcategory: "lingerie-sleepwear" }
        ]
      },
      {
        title: "Footwear",
        items: [
          { label: "Heels", subcategory: "heels" },
          { label: "Flats", subcategory: "flats" },
          { label: "Sandals", subcategory: "sandals" },
          { label: "Sneakers", subcategory: "sneakers" },
          { label: "Boots", subcategory: "boots" }
        ]
      },
      {
        title: "Accessories",
        items: [
          { label: "Jewelry", subcategory: "jewelry" },
          { label: "Bags & Purses", subcategory: "bags-purses" },
          { label: "Watches", subcategory: "watches" },
          { label: "Sunglasses", subcategory: "sunglasses" },
          { label: "Scarves & Hats", subcategory: "scarves-hats" },
          { label: "Hair Accessories", subcategory: "hair-accessories" }
        ]
      }
    ]
  },
  men: {
    title: "Men",
    sections: [
      {
        title: "Clothing",
        items: [
          { label: "T-Shirts & Polos", subcategory: "tshirts-polos" },
          { label: "Shirts", subcategory: "shirts" },
          { label: "Jeans", subcategory: "jeans" },
          { label: "Trousers & Shorts", subcategory: "trousers-shorts" },
          { label: "Jackets & Coats", subcategory: "jackets-coats" },
          { label: "Sweatshirts & Hoodies", subcategory: "sweatshirts-hoodies" },
          { label: "Innerwear & Sleepwear", subcategory: "innerwear-sleepwear" }
        ]
      },
      {
        title: "Footwear",
        items: [
          { label: "Casual Shoes", subcategory: "casual-shoes" },
          { label: "Formal Shoes", subcategory: "formal-shoes" },
          { label: "Sneakers", subcategory: "sneakers" },
          { label: "Sandals & Slides", subcategory: "sandals-slides" },
          { label: "Boots", subcategory: "boots" }
        ]
      },
      {
        title: "Accessories",
        items: [
          { label: "Watches", subcategory: "watches" },
          { label: "Wallets", subcategory: "wallets" },
          { label: "Belts", subcategory: "belts" },
          { label: "Sunglasses", subcategory: "sunglasses" },
          { label: "Caps & Hats", subcategory: "caps-hats" },
          { label: "Socks", subcategory: "socks" }
        ]
      }
    ]
  },
  kids: {
    title: "Kids",
    sections: [
      {
        title: "Boys",
        items: [
          { label: "Boys' Clothing", subcategory: "boys-clothing" },
          { label: "Boys' Footwear", subcategory: "boys-footwear" }
        ]
      },
      {
        title: "Girls",
        items: [
          { label: "Girls' Clothing", subcategory: "girls-clothing" },
          { label: "Girls' Footwear", subcategory: "girls-footwear" }
        ]
      },
      {
        title: "Other",
        items: [
          { label: "Toys & Games", subcategory: "toys-games" },
          { label: "Baby Essentials", subcategory: "baby-essentials" }
        ]
      }
    ]
  },
  bags: {
    title: "Bags & Luggage",
    sections: [
      {
        title: "Categories",
        items: [
          { label: "Backpacks", subcategory: "backpacks" },
          { label: "Handbags", subcategory: "handbags" },
          { label: "Sling Bags", subcategory: "sling-bags" },
          { label: "Laptop Bags", subcategory: "laptop-bags" },
          { label: "Trolley Bags", subcategory: "trolley-bags" },
          { label: "Wallets & Clutches", subcategory: "wallets-clutches" }
        ]
      }
    ]
  },
  beauty: {
    title: "Beauty & Personal Care",
    sections: [
      {
        title: "Categories",
        items: [
          { label: "Skincare", subcategory: "skincare" },
          { label: "Haircare", subcategory: "haircare" },
          { label: "Makeup", subcategory: "makeup" },
          { label: "Fragrances", subcategory: "fragrances" },
          { label: "Bath & Body", subcategory: "bath-body" }
        ]
      }
    ]
  },
  home: {
    title: "Home & Living",
    sections: [
      {
        title: "Categories",
        items: [
          { label: "Home Décor", subcategory: "home-decor" },
          { label: "Kitchen & Dining", subcategory: "kitchen-dining" },
          { label: "Lighting", subcategory: "lighting" }
        ]
      }
    ]
  },
  sports: {
    title: "Sports & Outdoors",
    sections: [
      {
        title: "Categories",
        items: [
          { label: "Fitness Equipment", subcategory: "fitness-equipment" },
          { label: "Sportswear", subcategory: "sportswear" }
        ]
      }
    ]
  },
  unisex: {
    title: "Unisex",
    sections: [
      {
        title: "Categories",
        items: [
          { label: "Clothing", subcategory: "clothing" },
          { label: "Footwear", subcategory: "footwear" },
          { label: "Bags & Accessories", subcategory: "bags-accessories" },
          { label: "Jewelry & Ornaments", subcategory: "jewelry-ornaments" },
          { label: "Hats", subcategory: "hats" },
          { label: "Sunglasses & Headwear", subcategory: "sunglasses-headwear" }
        ]
      }
    ]
  }
};
